import WidgetBase from '../widget.base';
import { duration } from '../../lib/const';
import { scrollTo } from '../../lib/util';

export default class GraphicalBanner extends WidgetBase {
    static selector = '[data-js-graphical-banner]';
    scrollBtn;
    pageWidgets;

    constructor(el){
        super(el);
        if(!el){
            return false;
        }

        this.scrollBtn = this.el.querySelector('[data-scroll-btn]');
        this.pageWidgets = document.querySelectorAll('div.layout__widget');

        this.scrollBtn.addEventListener('click', () => {
            const controlsOffsetY = window.pageYOffset + el.nextElementSibling.getBoundingClientRect().top - 50;

            scrollTo(document.scrollingElement, controlsOffsetY, duration);
        });

        setTimeout(() => {
            this.loaded();
        })
    }
}